import { Outlet, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { NavTabBar } from '@asad/crane-ui'

import { MissingDocumentsWarning } from '@/features/rodoDocuments/components/MissingDocumentsWarning'

const RODO_TABS = [
  { to: '/rodo/users-consents', labelKey: 'rodo.userConsents' },
  { to: '/rodo/privacy-policies', labelKey: 'rodo.privacyPolicies' },
  { to: '/rodo/data-processing-consents', labelKey: 'rodo.dataProcessingConsents' },
]

const RodoLayout = () => {
  const { pathname } = useLocation()
  const { t } = useTranslation()

  return (
    <div className='crane-ui-surface flex flex-col gap-3.5 text-crane-foreground'>
      <MissingDocumentsWarning />

      <NavTabBar items={RODO_TABS.map((tab) => ({ to: tab.to, label: t(tab.labelKey) }))} pathname={pathname} />

      <div className='flex flex-col gap-3.5'>
        <Outlet />
      </div>
    </div>
  )
}

export { RodoLayout }
export default RodoLayout
